<template>
  <div class="rightWrap">
    <div class="rtProductBox" :class="{ paused: paused }">
      <div class="flexItem" v-for="(item, index) in headProduct" :key="index">
        <div
          class="bnRtImg"
          v-for="(it, i) in item"
          :key="`1-${i}`"
          @mouseover="paused = true"
          @mouseleave="paused = false"
          :style="{ background: `url(${it.src}) center center no-repeat`, backgroundSize: 'cover' }"
          @click="openProducts(it.url)"
        ></div>
        <div
          class="bnRtImg"
          v-for="(it, i) in item"
          :key="`2-${i}`"
          @mouseover="paused = true"
          @mouseleave="paused = false"
          :style="{ background: `url(${it.src}) center center no-repeat`, backgroundSize: 'cover' }"
          @click="openProducts(it.url)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollProduct } from '@/utils/const'
export default {
  name: 'PcScrollProduct',
  data() {
    return {
      paused: false,
      visible: false,
      headProduct: scrollProduct
    }
  },
  props: [],
  computed: {},
  components: {},
  watch: {},
  methods: {
    openProducts(url) {
      window.open(url, '_blank')
    }
  },
  mounted() {},
  destroyed() {}
}
</script>

<style lang="less" scoped>
@-webkit-keyframes home-scroll-grid-infinite {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
@keyframes home-scroll-grid-infinite {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
.rightWrap {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: -56px;
  height: 1010px;
  width: 1020px;
  z-index: 0;
  background: url('../../../assets/homePage/head_bg.png') right top no-repeat;
  .rtProductBox {
    display: flex;
    padding-right: 15px;
    justify-content: right;
    animation-play-state: running;
    -webkit-animation-play-state: running;
    -webkit-animation: home-scroll-grid-infinite 30s linear 0s infinite;
    animation: home-scroll-grid-infinite 30s linear 0s infinite;
    &.paused {
      animation-play-state: paused;
      -webkit-animation-play-state: paused;
    }
    // &:hover {
    //   animation-play-state: paused;
    //   -webkit-animation-play-state: paused;
    // }
    .flexItem {
      .bnRtImg {
        width: 165px;
        height: 196px;
        margin: 14px 7px 0 7px;
        border-radius: 4px;
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s;
        cursor: pointer;
        &:hover {
          transform: scale(1.04);
          // box-shadow: 0 5px 20px 0 rgba(0 0 0, 0.1);
        }
      }
      &:nth-child(1) {
        margin-top: -50px;
      }
      &:nth-child(2) {
        margin-top: -130px;
      }
      &:nth-child(4) {
        margin-top: -100px;
      }
    }
  }
}
</style>
